export default __webpack_public_path__ + "static/media/MariaDB-WindowsTaskScheduler-Finish07.cb75ab21.png";